// SPDX-License-Identifier: MIT
// Decides whether the calm guided first-run is active. The predicate is PURE
// (storage is injected as `dismissed`) so it is fully unit-testable; the two
// thin helpers wrap localStorage. Guidance is additive — never load-bearing.
const DISMISS_KEY = 'genesis.guidance.dismissed';

export function isGuidedFirstRun(input: {
  projectCount: number;
  hasCompletedMagnify: boolean;
  dismissed: boolean;
}): boolean {
  if (input.dismissed) return false;
  return input.projectCount === 0 || !input.hasCompletedMagnify;
}

export function isGuidanceDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissGuidance(): void {
  try {
    localStorage.setItem(DISMISS_KEY, '1');
  } catch {
    /* storage unavailable — guidance simply re-shows next session, harmless */
  }
}
